import type { ComponentType } from 'react'
import {
  IconeAreaUsa, IconeArvore, IconeBarranco, IconeCanal, IconeCisterna, IconePonte, IconeBloqueador, IconeBombeiro, IconeBombeiroMedico,
  IconeCaminhao, IconeCaminhaoBombeiros, IconeCarro,
  IconeCone, IconeDefensa, IconeDerramamento, IconeDesfazer,
  IconeDestravado, IconeDetritosVidro, IconeEscada, IconeEstadoClinico, IconeExtintor, IconeFogo,
  IconeLonaFerramentas, IconeMaca, IconeManchaSangue, IconeMochilaTrauma,
  IconeMosquetao, IconePontoAncoragem, IconePlacaAncoragem, IconeEnvolvimento, IconeDescensor, IconeProtetorCorda, IconeMoto, IconeNoOito, IconeNoFiel, IconePoliaDupla, IconeSistemaVM, IconeTorre, IconeTrabalhador, IconeMuro, IconeOculto, IconePolia, IconePonto, IconePosicao, IconePoste, IconePrancha,
  IconeRefazer, IconeRiscoEletrico, IconeSuv, IconeTalude, IconeToco, IconeTravado, IconeVala,
  IconeVisivel, IconeVitima, IconeCavalo, IconeVaca, IconeEstaca, IconeCorda, type PropsIcone,
} from './icones'
import { useEffect, useMemo, useRef, useState, type ChangeEvent } from 'react'
import { SimulacaoEscada } from './tabletop/PainelSimulacoes'
import { useRecentes } from './tabletop/useRecentes'
import { InspetorVantagem } from './tabletop/PainelVantagem'
import { InspetorQueda } from './tabletop/PainelQueda'
import { BotaoEnvolverComFita, InspetorEnvolvimento } from './tabletop/PainelEnvolvimento'
import {
  CORES_TRIAGEM,
  CORES_USO_PONTO,
  MATERIAIS_ABSORVENTES,
  POSICOES_FINAIS_VEICULO,
  serializarCenaTabletop,
  type BlocoRiscoTabletop,
  type BlocoVeiculoTabletop,
  type BlocoVitimaTabletop,
  type CenaTabletop,
  type EstadoCortePecaTabletop,
  type IdPortaTabletop,
  type ItemFilaAtendimento,
  type ObjetoTabletop,
  type PosicaoFinalVeiculo,
  type PosturaVitimaSolo,
  type PrioridadeTriagem,
  type ResultadoIntervencaoVeiculoTabletop,
  type TipoObjetoTabletop,
  type TransformacaoTabletop,
  PRESETS_SALVAMENTO,
  ROTULOS_USO_PONTO,
  definicoesDeParametros,
  parametrosDoObjeto,
  pontosDeAncoragem,
  type ParametrosTabletop,
  temCordaNaRodana,
} from '../dominio/tabletop'
import type { NivelDanoVeicular, RegiaoDanoVeicular } from '../dominio/didatico/danoVeicular'
import { PERFIS_VEICULO, type AncoraOcupante } from '../dominio/didatico/perfilVeiculo'
import { IDS_PERFIL_VITIMA, perfilVitimaPorId } from '../dominio/didatico/perfisVitima'
import { CATALOGO_VIDROS, type FerramentaVidro, type IdVidro, type ResultadoAcaoVidro } from '../dominio/didatico/manejoVidros'
import type { FerramentaTabletop } from '../visualizacao3d/tabletop/CenaTabletop'
import { MATERIAIS_PADRAO_DERRAMAMENTO, ROTULOS_MATERIAL } from '../dominio/tabletop/riscosDaCena'
import { PECAS_INTERVENCAO_TABLETOP } from '../dominio/tabletop/pecasDeIntervencao'

const IDS_VIDRO = Object.keys(CATALOGO_VIDROS) as IdVidro[]

export const CATALOGO: ReadonlyArray<{
  categoria: 'Veículos' | 'Ambiente' | 'Pessoas' | 'Riscos' | 'Apoio Operacional' | 'Estabilização' | 'Vidros e proteção' | 'Cordas e altura' | 'Terreno'
  tipo: TipoObjetoTabletop
  rotulo: string
  Icone: ComponentType<PropsIcone>
}> = [
  { categoria: 'Veículos', tipo: 'carro', rotulo: 'Carro compacto', Icone: IconeCarro },
  { categoria: 'Veículos', tipo: 'suv', rotulo: 'SUV / sedan', Icone: IconeSuv },
  { categoria: 'Veículos', tipo: 'caminhao', rotulo: 'Caminhão', Icone: IconeCaminhao },
  { categoria: 'Veículos', tipo: 'resgate', rotulo: 'Resgate (ambulância vermelha)', Icone: IconeCaminhaoBombeiros },
  { categoria: 'Veículos', tipo: 'caminhaoBombeiros', rotulo: 'Caminhão de bombeiros (ABT)', Icone: IconeCaminhaoBombeiros },
  { categoria: 'Veículos', tipo: 'moto', rotulo: 'Motocicleta', Icone: IconeMoto },
  { categoria: 'Pessoas', tipo: 'vitima', rotulo: 'Vítima', Icone: IconeVitima },
  { categoria: 'Pessoas', tipo: 'cavalo', rotulo: 'Cavalo (500 kg)', Icone: IconeCavalo },
  { categoria: 'Pessoas', tipo: 'vaca', rotulo: 'Vaca (500 kg)', Icone: IconeVaca },
  { categoria: 'Pessoas', tipo: 'bombeiro', rotulo: 'Bombeiro (EPI)', Icone: IconeBombeiro },
  { categoria: 'Pessoas', tipo: 'bombeiroMedico', rotulo: 'Bombeiro médico (APH)', Icone: IconeBombeiroMedico },
  { categoria: 'Apoio Operacional', tipo: 'lonaFerramentas', rotulo: 'Lona de ferramentas', Icone: IconeLonaFerramentas },
  { categoria: 'Apoio Operacional', tipo: 'extintorPQS', rotulo: 'Extintor PQS', Icone: IconeExtintor },
  { categoria: 'Apoio Operacional', tipo: 'mochilaTrauma', rotulo: 'Mochila de trauma (APH)', Icone: IconeMochilaTrauma },
  { categoria: 'Apoio Operacional', tipo: 'prancha', rotulo: 'Prancha rígida', Icone: IconePrancha },
  { categoria: 'Apoio Operacional', tipo: 'areaUsa', rotulo: 'Área livre USA', Icone: IconeAreaUsa },
  { categoria: 'Cordas e altura', tipo: 'escada', rotulo: 'Escada', Icone: IconeEscada },
  { categoria: 'Cordas e altura', tipo: 'toco', rotulo: 'Toco de árvore', Icone: IconeToco },
  { categoria: 'Cordas e altura', tipo: 'estaca', rotulo: 'Estaca de ancoragem (solo)', Icone: IconeEstaca },
  { categoria: 'Cordas e altura', tipo: 'maca', rotulo: 'Maca de resgate', Icone: IconeMaca },
  { categoria: 'Cordas e altura', tipo: 'polia', rotulo: 'Polia', Icone: IconePolia },
  { categoria: 'Cordas e altura', tipo: 'pontoAncoragem', rotulo: 'Ponto de ancoragem', Icone: IconePontoAncoragem },
  { categoria: 'Cordas e altura', tipo: 'placaAncoragem', rotulo: 'Placa de ancoragem', Icone: IconePlacaAncoragem },
  { categoria: 'Cordas e altura', tipo: 'envolvimento', rotulo: 'Ancoragem por envolvimento', Icone: IconeEnvolvimento },
  { categoria: 'Cordas e altura', tipo: 'descensor', rotulo: 'Descensor', Icone: IconeDescensor },
  { categoria: 'Cordas e altura', tipo: 'protetorCorda', rotulo: 'Protetor de corda', Icone: IconeProtetorCorda },
  { categoria: 'Cordas e altura', tipo: 'mosquetao', rotulo: 'Mosquetão', Icone: IconeMosquetao },
  { categoria: 'Cordas e altura', tipo: 'bloqueador', rotulo: 'Bloqueador', Icone: IconeBloqueador },
  // os nós não estão aqui: o nó é da ponta da corda ("Nó nas pontas"), não uma peça solta
  { categoria: 'Cordas e altura', tipo: 'poliaDupla', rotulo: 'Polia dupla', Icone: IconePoliaDupla },
  { categoria: 'Cordas e altura', tipo: 'sistemaVM', rotulo: 'Sistema de vantagem (redução de força)', Icone: IconeSistemaVM },
  { categoria: 'Cordas e altura', tipo: 'trabalhador', rotulo: 'Trabalhador em altura', Icone: IconeTrabalhador },
  { categoria: 'Cordas e altura', tipo: 'torre', rotulo: 'Torre', Icone: IconeTorre },
  { categoria: 'Terreno', tipo: 'talude', rotulo: 'Talude', Icone: IconeTalude },
  { categoria: 'Terreno', tipo: 'barranco', rotulo: 'Barranco', Icone: IconeBarranco },
  { categoria: 'Terreno', tipo: 'vala', rotulo: 'Vala', Icone: IconeVala },
  { categoria: 'Terreno', tipo: 'canal', rotulo: 'Canal em concreto', Icone: IconeCanal },
  { categoria: 'Terreno', tipo: 'ponte', rotulo: 'Ponte', Icone: IconePonte },
  { categoria: 'Terreno', tipo: 'cisterna', rotulo: 'Cisterna', Icone: IconeCisterna },
  { categoria: 'Riscos', tipo: 'detritosVidro', rotulo: 'Detritos de vidro', Icone: IconeDetritosVidro },
  { categoria: 'Riscos', tipo: 'derramamento', rotulo: 'Mancha de óleo', Icone: IconeDerramamento },
  { categoria: 'Riscos', tipo: 'caboEletrico', rotulo: 'Cabo energizado', Icone: IconeRiscoEletrico },
  { categoria: 'Riscos', tipo: 'manchaSangue', rotulo: 'Mancha de sangue', Icone: IconeManchaSangue },
  { categoria: 'Riscos', tipo: 'fogo', rotulo: 'Fogo / Princípio de incêndio', Icone: IconeFogo },
  { categoria: 'Ambiente', tipo: 'arvore', rotulo: 'Árvore', Icone: IconeArvore },
  { categoria: 'Ambiente', tipo: 'poste', rotulo: 'Poste', Icone: IconePoste },
  { categoria: 'Ambiente', tipo: 'defensa', rotulo: 'Defensa', Icone: IconeDefensa },
  { categoria: 'Ambiente', tipo: 'muro', rotulo: 'Muro', Icone: IconeMuro },
  { categoria: 'Ambiente', tipo: 'cone', rotulo: 'Cone', Icone: IconeCone },
]

const ORDEM_CATEGORIAS = ['Veículos', 'Pessoas', 'Terreno', 'Cordas e altura', 'Riscos', 'Apoio Operacional', 'Estabilização', 'Vidros e proteção', 'Ambiente'] as const

/**
 * Assistente opcional "Montar do zero" (B7): cada passo filtra a bandeja
 * pra categoria certa, sem impedir quem prefere montar livremente — por
 * isso o passo começa em `null` (nenhum filtro) e só existe enquanto o
 * instrutor optar por segui-lo.
 */
const PASSOS_ASSISTENTE = [
  { id: 0, rotulo: '1. Veículos', categorias: ['Veículos'] as const },
  { id: 1, rotulo: '2. Vítimas', categorias: ['Pessoas'] as const },
  { id: 2, rotulo: '3. Riscos e obstáculos', categorias: ['Terreno', 'Cordas e altura', 'Riscos', 'Apoio Operacional', 'Ambiente', 'Vidros e proteção', 'Estabilização'] as const },
  { id: 3, rotulo: '4. Revisar', categorias: [] as const },
] as const

type PassoAssistente = (typeof PASSOS_ASSISTENTE)[number]['id']

const ROTULOS_TRIAGEM: Record<PrioridadeTriagem, string> = {
  vermelho: 'Vermelho — crítico',
  amarelo: 'Amarelo — urgente',
  verde: 'Verde — leve',
  preto: 'Preto — óbito',
}

const ROTULOS_POSICAO_FINAL: Record<PosicaoFinalVeiculo, string> = {
  sobreRodas: 'Sobre rodas',
  tombadoEsquerdo: 'Tombado (esquerdo)',
  tombadoDireito: 'Tombado (direito)',
  capotado: 'Capotado',
  sobreOutroVeiculo: 'Sobre outro veículo',
}

const ROTULOS_POSTURA_SOLO: Record<PosturaVitimaSolo, string> = {
  emPe: 'Em pé',
  sentada: 'Sentada',
  decubitoDorsal: 'Decúbito dorsal',
  decubitoVentral: 'Decúbito ventral',
  decubitoLateral: 'Decúbito lateral',
}

export type SecaoPainelTabletop =
  | 'adicionar'
  | 'ferramentas'
  | 'editor'
  | 'fila'
  | 'objetos'
  | 'cena'
  | 'io'

export interface PresetsDoInstrutorDoPainel {
  readonly lista: readonly { id: string; nome: string; criadoEm: number }[]
  readonly aoSalvar: (nome: string) => { sucesso: boolean; mensagem: string }
  /** Abre o preset em Montar; devolve `false` se o conteúdo guardado não abriu. */
  readonly aoAbrir: (id: string) => boolean
  readonly aoExcluir: (id: string) => void
}

interface Props {
  montagemSimples?: boolean
  /** Limita o conteúdo exibido; sem esta prop, o painel completo é preservado. */
  secoes?: readonly SecaoPainelTabletop[]
  cena: CenaTabletop
  selecionado: ObjetoTabletop | null
  ferramenta: FerramentaTabletop
  fila: readonly ItemFilaAtendimento[]
  podeDesfazer: boolean
  podeRefazer: boolean
  cenarioTravado?: boolean
  aoAlternarTravaCenario?: () => void
  aoSelecionar: (id: string | null) => void
  aoEscolherFerramenta: (ferramenta: FerramentaTabletop) => void
  aoAdicionar: (tipo: TipoObjetoTabletop) => void
  /** B2: em vez de nascer num canto, a peça aguarda o próximo toque no chão da cena. */
  aoIniciarPosicionamento: (tipo: TipoObjetoTabletop) => void
  /**
   * Pegar uma corda (ou uma fita) no catálogo: toca-se nos pontos de ancoragem
   * e só depois se escolhe o que ela é. Sem isto, o catálogo não oferece cordas.
   */
  aoIniciarCorda?: (funcao: 'livre' | 'fita') => void
  aoTransformar: (id: string, transformacao: TransformacaoTabletop) => void
  aoRenomearObjeto: (id: string, nome: string) => void
  aoAlterarCor: (id: string, cor: string) => void
  aoDuplicar: (id: string) => void
  aoRemover: (id: string) => void
  aoResetar: (id: string) => void
  aoRenomearCena: (nome: string) => void
  aoCriarCena: () => void
  /** Apaga tudo (cena, histórico, sessão e o que está guardado no navegador) e volta ao cenário padrão. Sem esta prop, o botão não aparece. */
  aoRedefinirTudo?: () => void
  aoCarregarExemplo: (idPreset?: string) => void
  aoImportar: (conteudo: string) => { sucesso: boolean; mensagem: string }
  /** Montagens que o instrutor salvou como preset. Sem esta prop, a seção "Meus presets" não aparece. */
  presetsDoInstrutor?: PresetsDoInstrutorDoPainel
  aoDesfazer: () => void
  aoRefazer: () => void
  aoDesvincularVitima: (idVitima: string, postura?: PosturaVitimaSolo) => void
  aoMoverNaFila: (idVitima: string, direcao: 'subir' | 'descer') => void
  ancorasLivres: (idVeiculo: string) => AncoraOcupante[]
  aoAtualizarVitima: (id: string, alteracoes: Partial<BlocoVitimaTabletop>) => void
  /** Configuração de um risco (ex.: vazamento ativo, materiais aceitos). Sem o callback, o editor não aparece. */
  aoAtualizarRisco?: (id: string, alteracoes: Partial<BlocoRiscoTabletop>) => void
  /** Medidas do objeto (ângulo da escada, altura do toco...). Sem o callback, o editor de medidas não aparece. */
  aoAtualizarParametros?: (id: string, parametros: ParametrosTabletop) => void
  /** Põe uma fita em volta do tronco da peça (árvore, poste, toco). */
  aoEnvolverComFita?: (id: string) => void
  /** Acomoda a polia na corda que passa pela roldana. */
  aoAlinharPolia?: (id: string) => void
  /** Envolve um controle contínuo (deslizante): a edição inteira vira um passo só de desfazer. */
  aoAlterarEdicaoContinua?: (ativa: boolean) => void
  aoAtualizarVeiculo: (id: string, alteracoes: Partial<BlocoVeiculoTabletop>) => void
  aoDefinirPosicaoFinal: (id: string, posicaoFinal: PosicaoFinalVeiculo) => void
  aoExecutarManejoVidro: (idVeiculo: string, idVidro: IdVidro, ferramenta: FerramentaVidro) => void
  aoRestaurarVidros: (idVeiculo: string) => void
  ultimoResultadoVidro: ResultadoAcaoVidro | null
  aoAplicarDeformacao?: (idVeiculo: string, nivel: NivelDanoVeicular | 'nenhum', intrusaoM?: number, regiao?: RegiaoDanoVeicular, idPorta?: IdPortaTabletop) => void
  pincel?: {
    ativo: boolean
    larguraM: number
    intrusaoM: number
    aoAlternar: (ativo: boolean) => void
    aoDefinirLargura: (valor: number) => void
    aoDefinirIntrusao: (valor: number) => void
    aoRestaurar: (idVeiculo: string) => void
  }
  aoExecutarCorte?: (idVeiculo: string, idPeca: string, novoEstado: EstadoCortePecaTabletop) => void
  aoSelecionarPecaVeiculo?: (idVeiculo: string, idPeca: string | null) => void
  aoRestaurarEstrutura?: (idVeiculo: string) => void
  ultimoResultadoCorte?: ResultadoIntervencaoVeiculoTabletop | null
  aoAlternarBloqueio: (id: string, bloqueado: boolean) => void
  aoAlternarOculto: (id: string, oculto: boolean) => void
  aoResetarPosicaoSoltura?: (id: string) => void
}

export function PainelTabletop(props: Props) {
  const arquivoRef = useRef<HTMLInputElement>(null)
  const [mensagemImportacao, setMensagemImportacao] = useState<{
    texto: string
    sucesso: boolean
  } | null>(null)
  // B7: `null` = montagem livre (comportamento de sempre); um número ativa o assistente
  const [passoAssistente, setPassoAssistente] = useState<PassoAssistente | null>(null)
  const { recentes, registrar: registrarRecente } = useRecentes()
  const escolherPeca = (tipo: TipoObjetoTabletop) => {
    registrarRecente(tipo)
    props.aoIniciarPosicionamento(tipo)
  }
  const [confirmandoRedefinir, setConfirmandoRedefinir] = useState(false)

  const importar = async (evento: ChangeEvent<HTMLInputElement>) => {
    const arquivo = evento.target.files?.[0]
    evento.target.value = ''
    if (!arquivo) return
    if (arquivo.size > 5 * 1024 * 1024) {
      setMensagemImportacao({ texto: 'O arquivo excede o limite de 5 MB.', sucesso: false })
      return
    }
    try {
      const resultado = props.aoImportar(await arquivo.text())
      setMensagemImportacao({ texto: resultado.mensagem, sucesso: resultado.sucesso })
    } catch {
      setMensagemImportacao({ texto: 'Não foi possível ler o arquivo selecionado.', sucesso: false })
    }
  }

  const exportar = () => {
    let conteudo: string
    try {
      conteudo = serializarCenaTabletop(props.cena)
    } catch {
      setMensagemImportacao({
        texto: 'A cena contém uma transformação inválida e não pôde ser exportada.',
        sucesso: false,
      })
      return
    }
    const url = URL.createObjectURL(new Blob([conteudo], { type: 'application/json' }))
    const link = document.createElement('a')
    const nomeSeguro = props.cena.nome
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase() || 'tabletop'
    link.href = url
    link.download = `${nomeSeguro}.json`
    document.body.append(link)
    link.click()
    link.remove()
    window.setTimeout(() => URL.revokeObjectURL(url), 0)
  }

  const veiculos = props.cena.objetos.filter((o) => o.veiculo)
  const exibe = (secao: SecaoPainelTabletop) => !props.secoes || props.secoes.includes(secao)

  return (
    <>
      {exibe('ferramentas') && (
        <div className="grupo-controle">
          <span className="titulo-controle">Ferramentas</span>
          <div className="acoes-cena-tabletop">
            <button onClick={props.aoDesfazer} disabled={!props.podeDesfazer} title="Desfazer (Ctrl+Z)"><IconeDesfazer />Desfazer</button>
            <button onClick={props.aoRefazer} disabled={!props.podeRefazer} title="Refazer (Ctrl+Shift+Z)"><IconeRefazer />Refazer</button>
            {props.aoAlternarTravaCenario && (
              <button
                type="button"
                className={`botao-trava-cenario ${props.cenarioTravado ? 'botao-trava-cenario--ativo' : ''}`}
                onClick={props.aoAlternarTravaCenario}
                title={
                  props.cenarioTravado
                    ? 'Cenário travado: veículos e obstáculos fixos. Clique para destravar.'
                    : 'Travar cenário: fixa veículos e obstáculos para apenas entrar e sair ferramentas.'
                }
              >
                {props.cenarioTravado ? <><IconeTravado /> Cenário Travado</> : <><IconeDestravado /> Travar Cenário</>}
              </button>
            )}
          </div>
        </div>
      )}

      {/* Seleção rápida direta de vítimas presentes no cenário */}
      {(exibe('objetos') || exibe('fila')) && props.cena.objetos.some((o) => o.tipo === 'vitima') && (
        <div className="grupo-controle seletor-rapido-vitimas-grupo">
          <span className="titulo-controle">Vítimas na cena (clique para focar)</span>
          <div className="seletor-rapido-vitimas-chips" role="group" aria-label="Vítimas no cenário">
            {props.cena.objetos
              .filter((o) => o.tipo === 'vitima')
              .map((v) => {
                const estaNoVeiculo = v.vitima?.local.tipo === 'veiculo'
                const veiculoPai = estaNoVeiculo ? props.cena.objetos.find((o) => o.id === (v.vitima?.local as any)?.idVeiculo) : null
                const localTexto = estaNoVeiculo ? (veiculoPai?.nome ?? 'Veículo') : 'Solo'
                const papel = v.nome
                const triagem = v.vitima?.triagem ?? 'amarelo'
                const selecionado = props.selecionado?.id === v.id
                return (
                  <button
                    key={v.id}
                    type="button"
                    className={`chip-vitima-tabletop chip-vitima-tabletop--${triagem} ${selecionado ? 'chip-vitima-tabletop--selecionado' : ''}`}
                    onClick={() => props.aoSelecionar(v.id)}
                    title={`Selecionar ${v.nome} (${localTexto})`}
                  >
                    <span className="chip-vitima-tabletop__icone"><IconeVitima tamanho={14} /></span>
                    <span className="chip-vitima-tabletop__nome">{papel}</span>
                    <span className="chip-vitima-tabletop__local">{localTexto}</span>
                  </button>
                )
              })}
          </div>
        </div>
      )}

      {exibe('adicionar') && (
      <div className="grupo-controle">
        <span className="titulo-controle">Adicionar objetos</span>

        {!props.montagemSimples && <div className="tt-assistente-passos" role="group" aria-label="Assistente de montagem">
          <button
            type="button"
            className={`tt-assistente-passo ${passoAssistente === null ? 'tt-assistente-passo--ativo' : ''}`}
            onClick={() => setPassoAssistente(null)}
          >
            Montagem livre
          </button>
          {PASSOS_ASSISTENTE.map((passo) => (
            <button
              key={passo.id}
              type="button"
              className={`tt-assistente-passo ${passoAssistente === passo.id ? 'tt-assistente-passo--ativo' : ''}`}
              onClick={() => setPassoAssistente(passo.id)}
            >
              {passo.rotulo}
            </button>
          ))}
        </div>}

        {!props.montagemSimples && passoAssistente === 3 ? (
          <RevisaoAssistenteMontagem cena={props.cena} />
        ) : (
          <>
            <p className="dica-tabletop">
              {props.montagemSimples || passoAssistente === null
                ? 'Toque numa peça e depois toque no chão da cena para posicioná-la ali. '
                : `Passo ${PASSOS_ASSISTENTE[passoAssistente].rotulo.toLowerCase()}: escolha a peça e toque no chão da cena para posicioná-la ali.`}
            </p>
            {recentes.length > 0 && (
              <div className="grupo-catalogo-tabletop grupo-catalogo-tabletop--recentes">
                <span>Recentes</span>
                <div className="catalogo-tabletop">
                  {recentes.flatMap((tipo) => {
                    const item = CATALOGO.find((c) => c.tipo === tipo)
                    return item ? [item] : []
                  }).map((item) => (
                    <button
                      key={item.tipo}
                      onClick={() => escolherPeca(item.tipo)}
                      aria-label={`Recente: posicionar ${item.rotulo}`}
                      title={`Posicionar ${item.rotulo} de novo`}
                    >
                      <item.Icone />
                      {item.rotulo}
                    </button>
                  ))}
                </div>
              </div>
            )}
            {ORDEM_CATEGORIAS
              .filter(
                (categoria) =>
                  props.montagemSimples || passoAssistente === null ||
                  (PASSOS_ASSISTENTE[passoAssistente].categorias as readonly string[]).includes(categoria),
              )
              .map((categoria) => (
              <div key={categoria} className="grupo-catalogo-tabletop">
                <span>{categoria}</span>
                <div className="catalogo-tabletop">
                  {/* a corda e a fita se pegam como as peças: toque nelas e depois nos pontos de ancoragem */}
                  {categoria === 'Cordas e altura' && props.aoIniciarCorda && (
                    <>
                      <button
                        type="button"
                        onClick={() => props.aoIniciarCorda!('livre')}
                        aria-label="Pegar uma corda"
                        title="Pegar uma corda: toque nos pontos de ancoragem por onde ela passa e depois escolha o que ela é"
                      >
                        <IconeCorda />
                        Corda
                      </button>
                      <button
                        type="button"
                        onClick={() => props.aoIniciarCorda!('fita')}
                        aria-label="Pegar uma fita"
                        title="Pegar uma fita de ancoragem: toque no ponto que ela abraça e no ponto em que termina"
                      >
                        <IconeEnvolvimento />
                        Fita
                      </button>
                    </>
                  )}
                  {CATALOGO.filter((item) => item.categoria === categoria).map((item) => (
                    <button
                      key={item.tipo}
                      onClick={() => escolherPeca(item.tipo)}
                      aria-label={`Posicionar ${item.rotulo}`}
                      title={`Posicionar ${item.rotulo}`}
                    >
                      <item.Icone />
                      {item.rotulo}
                    </button>
                  ))}
                </div>
              </div>
            ))}
          </>
        )}
      </div>
      )}

      {exibe('editor') && (
      <div className="grupo-controle editor-tabletop">
        <span className="titulo-controle">Objeto selecionado</span>
        {!props.selecionado ? (
          <p className="dica">Selecione um objeto no cenário ou na lista para editar.</p>
        ) : (
          <>
            <label className="campo">
              <span>nome</span>
              <input
                value={props.selecionado.nome}
                required
                onChange={(e) => props.aoRenomearObjeto(
                  props.selecionado!.id,
                  e.target.value.trim().length > 0 ? e.target.value : 'Sem nome',
                )}
              />
            </label>
            {['carro', 'suv', 'caminhao', 'moto', 'resgate'].includes(props.selecionado.tipo) && (
              <label className="campo campo-cor-tabletop">
                <span>cor do veículo</span>
                <input
                  type="color"
                  value={props.selecionado.cor ?? '#374151'}
                  onChange={(e) => props.aoAlterarCor(props.selecionado!.id, e.target.value)}
                />
              </label>
            )}

            {props.selecionado.veiculo && (
              <InspetorVeiculo
                modoSimples={props.montagemSimples}
                objeto={props.selecionado}
                veiculo={props.selecionado.veiculo}
                cena={props.cena}
                aoAtualizarVeiculo={props.aoAtualizarVeiculo}
                aoDefinirPosicaoFinal={props.aoDefinirPosicaoFinal}
                aoExecutarManejoVidro={props.aoExecutarManejoVidro}
                aoRestaurarVidros={props.aoRestaurarVidros}
                ultimoResultadoVidro={props.ultimoResultadoVidro}
                aoAplicarDeformacao={props.aoAplicarDeformacao}
                pincel={props.montagemSimples ? props.pincel : undefined}
                aoExecutarCorte={props.aoExecutarCorte}
                aoSelecionarPecaVeiculo={props.aoSelecionarPecaVeiculo}
                aoRestaurarEstrutura={props.aoRestaurarEstrutura}
                ultimoResultadoCorte={props.ultimoResultadoCorte}
                aoSelecionar={props.aoSelecionar}
              />
            )}

            {props.selecionado.vitima && (
              <InspetorVitima
                objeto={props.selecionado}
                vitima={props.selecionado.vitima}
                veiculos={veiculos}
                ancorasLivres={props.ancorasLivres}
                aoAtualizarVitima={props.aoAtualizarVitima}
                modoSimples={props.montagemSimples}
                aoDesvincularVitima={props.aoDesvincularVitima}
              />
            )}

            {props.selecionado.tipo === 'escada' && <SimulacaoEscada objeto={props.selecionado} />}
            {props.selecionado.tipo === 'sistemaVM' && <InspetorVantagem objeto={props.selecionado} />}
            {props.selecionado.tipo === 'trabalhador' && (
              <InspetorQueda
                cena={props.cena}
                objeto={props.selecionado}
                aoResetarSoltura={props.aoResetarPosicaoSoltura}
              />
            )}
            {props.selecionado.tipo === 'envolvimento' && (
              <InspetorEnvolvimento objeto={props.selecionado} aoAtualizarParametros={props.aoAtualizarParametros} />
            )}
            {props.aoAlinharPolia && (props.selecionado.tipo === 'polia' || props.selecionado.tipo === 'poliaDupla') && temCordaNaRodana(props.cena, props.selecionado) && (
              <div className="acoes-linha">
                <button type="button" className="btn-acao-cad btn-acao-cad--secundario" onClick={() => props.aoAlinharPolia!(props.selecionado!.id)}>
                  Alinhar com a corda
                </button>
                <span className="dica">Gira a polia para a roldana ficar no plano da corda e o olhal apontar para a ancoragem.</span>
              </div>
            )}
            {props.aoEnvolverComFita && ['arvore', 'poste', 'toco'].includes(props.selecionado.tipo) && (
              <BotaoEnvolverComFita objeto={props.selecionado} aoEnvolver={props.aoEnvolverComFita} />
            )}

            <InspetorAncoragem
              objeto={props.selecionado}
              aoAtualizarParametros={props.aoAtualizarParametros}
              aoAlterarEdicaoContinua={props.aoAlterarEdicaoContinua}
            />

            {props.selecionado.tipo === 'derramamento' && props.aoAtualizarRisco && (
              <InspetorDerramamento objeto={props.selecionado} aoAtualizarRisco={props.aoAtualizarRisco} />
            )}

            <details>
              <summary>Ajustes avançados</summary>
              <fieldset disabled={Boolean(props.selecionado.bloqueado || (props.cenarioTravado && !props.selecionado.equipamento) || props.selecionado.vitima?.local.tipo === 'veiculo')}>
            <div className="ferramentas-tabletop" role="group" aria-label="Ferramenta de transformação">
              {([
                ['translate', 'Mover'],
                ['rotate', 'Girar'],
                ['scale', 'Escalar'],
              ] as const).map(([ferramenta, rotulo]) => (
                <button
                  key={ferramenta}
                  className={props.ferramenta === ferramenta ? 'ativo' : ''}
                  onClick={() => props.aoEscolherFerramenta(ferramenta)}
                >
                  {rotulo}
                </button>
              ))}
            </div>
            <EditorVetor
              rotulo="posição (m)"
              valores={props.selecionado.transformacao.posicao}
              aoAlterar={(posicao) => props.aoTransformar(props.selecionado!.id, {
                ...props.selecionado!.transformacao,
                posicao,
              })}
            />
            <EditorVetor
              rotulo="rotação (graus)"
              valores={props.selecionado.transformacao.rotacao.map(radianoParaGrau) as [number, number, number]}
              passo={5}
              aoAlterar={(graus) => props.aoTransformar(props.selecionado!.id, {
                ...props.selecionado!.transformacao,
                rotacao: graus.map(grauParaRadiano) as [number, number, number],
              })}
            />
            <EditorVetor
              rotulo="escala"
              valores={props.selecionado.transformacao.escala}
              minimo={0.05}
              aoAlterar={(escala) => props.aoTransformar(props.selecionado!.id, {
                ...props.selecionado!.transformacao,
                escala,
              })}
            />
              </fieldset>
            </details>
            <div className="acoes-tabletop">
              <button
                onClick={() => props.aoTransformar(props.selecionado!.id, {
                  ...props.selecionado!.transformacao,
                  posicao: [props.selecionado!.transformacao.posicao[0], 0, props.selecionado!.transformacao.posicao[2]],
                })}
                title="Zera a altura (Y), mantendo X/Z"
              >
                Assentar no solo
              </button>
              <button onClick={() => props.aoDuplicar(props.selecionado!.id)}>Duplicar</button>
              <button onClick={() => props.aoResetar(props.selecionado!.id)}>Resetar</button>
              <button className="perigo" onClick={() => props.aoRemover(props.selecionado!.id)}>Excluir</button>
            </div>
          </>
        )}
      </div>
      )}

      {exibe('objetos') && props.cena.objetos.length > 0 && (
        <div className="grupo-controle">
          <span className="titulo-controle">Objetos na cena ({props.cena.objetos.length})</span>
          <div className="lista-objetos-tabletop">
            {props.cena.objetos.map((objeto) => (
              <div key={objeto.id} className="item-lista-tabletop">
                <button
                  className={objeto.id === props.selecionado?.id ? 'ativo' : ''}
                  onClick={() => props.aoSelecionar(objeto.id)}
                >
                  {objeto.nome}
                </button>
                <button
                  className="icone-lista-tabletop"
                  aria-label={objeto.oculto ? `Mostrar ${objeto.nome}` : `Ocultar ${objeto.nome}`}
                  title={objeto.oculto ? 'Mostrar' : 'Ocultar'}
                  onClick={() => props.aoAlternarOculto(objeto.id, !objeto.oculto)}
                >
                  {objeto.oculto ? <IconeOculto /> : <IconeVisivel />}
                </button>
                <button
                  className="icone-lista-tabletop"
                  aria-label={objeto.bloqueado ? `Destravar ${objeto.nome}` : `Travar ${objeto.nome}`}
                  title={objeto.bloqueado ? 'Destravar' : 'Travar'}
                  onClick={() => props.aoAlternarBloqueio(objeto.id, !objeto.bloqueado)}
                >
                  {objeto.bloqueado ? <IconeTravado /> : <IconeDestravado />}
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

      {exibe('cena') && (
      <div className="grupo-controle">
        <span className="titulo-controle">Cena</span>
        <label className="campo">
          <span>nome do table top</span>
          <input value={props.cena.nome} onChange={(e) => props.aoRenomearCena(e.target.value)} />
        </label>
        <div className="acoes-cena-tabletop">
          <button onClick={props.aoCriarCena}>Novo table top</button>
          {props.aoRedefinirTudo && !confirmandoRedefinir && (
            <button type="button" className="perigo" onClick={() => setConfirmandoRedefinir(true)}>
              Redefinir tudo
            </button>
          )}
        </div>
        {props.aoRedefinirTudo && confirmandoRedefinir && (
          <div className="confirmar-redefinir-tabletop" role="alertdialog" aria-label="Confirmar redefinição">
            <p className="dica">
              Apaga a cena, o desfazer e o que está salvo neste navegador, e volta ao cenário padrão.
              Os presets e o JSON que você guardou não mudam.
            </p>
            <div className="acoes-cena-tabletop">
              <button
                type="button"
                className="perigo"
                onClick={() => {
                  setConfirmandoRedefinir(false)
                  props.aoRedefinirTudo?.()
                }}
              >
                Sim, redefinir tudo
              </button>
              <button type="button" onClick={() => setConfirmandoRedefinir(false)}>Cancelar</button>
            </div>
          </div>
        )}

        {props.presetsDoInstrutor && <MeusPresets {...props.presetsDoInstrutor} nomeSugerido={props.cena.nome} />}

        <div className="seletor-cenarios-tabletop">
          <span className="titulo-controle" style={{ marginTop: '14px', display: 'block' }}>
            Técnicas de salvamento
          </span>
          <p className="dica">
            Cenários de exemplo de salvamento terrestre e em altura. Abrem para editar: mexa nos objetos, troque as cordas
            ou monte a sua variação.
          </p>
          <div className="tt-galeria-cenarios">
            {PRESETS_SALVAMENTO.map((preset) => (
              <button
                key={preset.id}
                type="button"
                className="tt-cartao-cenario"
                onClick={() => props.aoCarregarExemplo(preset.id)}
              >
                <div className="tt-cartao-cenario__cabecalho">
                  <strong>{preset.titulo}</strong>
                </div>
                <p className="tt-cartao-cenario__descricao">{preset.descricao}</p>
              </button>
            ))}
          </div>
        </div>

        <p className="salvamento-tabletop" style={{ marginTop: '12px' }}><IconePonto />Salvamento automático ativo neste navegador</p>
      </div>
      )}

      {exibe('io') && (
      <div className="grupo-controle">
        <span className="titulo-controle">Importar e exportar</span>
        <div className="acoes-cena-tabletop">
          <button onClick={exportar}>Exportar JSON</button>
          <button onClick={() => arquivoRef.current?.click()}>Importar JSON</button>
        </div>
        <input ref={arquivoRef} className="arquivo-tabletop" type="file" accept="application/json,.json" onChange={importar} />
        {mensagemImportacao && (
          <p
            className={`mensagem-importacao ${mensagemImportacao.sucesso ? 'sucesso' : 'erro'}`}
            role="status"
          >
            {mensagemImportacao.texto}
          </p>
        )}
      </div>
      )}
    </>
  )
}


/** Salvar a montagem aberta como preset e reabrir as que já foram salvas, neste navegador. */
export function MeusPresets({
  lista,
  aoSalvar,
  aoAbrir,
  aoExcluir,
  nomeSugerido,
}: PresetsDoInstrutorDoPainel & { nomeSugerido: string }) {
  const [nome, setNome] = useState('')
  const [mensagem, setMensagem] = useState<{ texto: string; sucesso: boolean } | null>(null)
  const formatarData = (instante: number) =>
    new Date(instante).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })

  return (
    <div className="seletor-cenarios-tabletop meus-presets">
      <span className="titulo-controle" style={{ marginTop: '14px', display: 'block' }}>
        Meus presets
      </span>
      <p className="dica">Salve a montagem que está na mesa para reabrir numa aula. Ficam guardados neste navegador.</p>
      <form
        className="acoes-cena-tabletop"
        onSubmit={(e) => {
          e.preventDefault()
          const resultado = aoSalvar(nome)
          setMensagem({ texto: resultado.mensagem, sucesso: resultado.sucesso })
          if (resultado.sucesso) setNome('')
        }}
      >
        <input
          aria-label="Nome do preset"
          placeholder={nomeSugerido || 'Nome do preset'}
          maxLength={60}
          value={nome}
          onChange={(e) => setNome(e.target.value)}
        />
        <button type="submit">Salvar como preset</button>
      </form>
      {mensagem && (
        <p className={`mensagem-importacao ${mensagem.sucesso ? 'sucesso' : 'erro'}`} role="status">
          {mensagem.texto}
        </p>
      )}
      {lista.length === 0 ? (
        <p className="dica">Nenhum preset seu ainda.</p>
      ) : (
        <ul className="lista-pontos-ancoragem">
          {lista.map((preset) => (
            <li key={preset.id}>
              <button
                type="button"
                className="btn-link-corda"
                onClick={() => {
                  const abriu = aoAbrir(preset.id)
                  setMensagem(abriu ? null : { texto: `Não foi possível abrir "${preset.nome}": o conteúdo guardado está inválido.`, sucesso: false })
                }}
              >
                {preset.nome}
              </button>{' '}
              <span className="dica">({formatarData(preset.criadoEm)})</span>{' '}
              <button type="button" className="btn-link-corda" aria-label={`Excluir o preset ${preset.nome}`} onClick={() => aoExcluir(preset.id)}>
                Excluir
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

function InspetorVeiculo({
  modoSimples,
  objeto,
  veiculo,
  cena,
  aoAtualizarVeiculo,
  aoDefinirPosicaoFinal,
  aoExecutarManejoVidro,
  aoRestaurarVidros,
  ultimoResultadoVidro,
  aoAplicarDeformacao,
  pincel,
  aoExecutarCorte,
  aoSelecionarPecaVeiculo,
  aoRestaurarEstrutura,
  ultimoResultadoCorte,
  aoSelecionar,
}: {
  modoSimples?: boolean
  objeto: ObjetoTabletop
  veiculo: BlocoVeiculoTabletop
  cena: CenaTabletop
  aoAtualizarVeiculo: Props['aoAtualizarVeiculo']
  aoDefinirPosicaoFinal: Props['aoDefinirPosicaoFinal']
  aoExecutarManejoVidro: Props['aoExecutarManejoVidro']
  aoRestaurarVidros: Props['aoRestaurarVidros']
  ultimoResultadoVidro: Props['ultimoResultadoVidro']
  aoAplicarDeformacao?: Props['aoAplicarDeformacao']
  pincel?: Props['pincel']
  aoExecutarCorte?: Props['aoExecutarCorte']
  aoSelecionarPecaVeiculo?: Props['aoSelecionarPecaVeiculo']
  aoRestaurarEstrutura?: Props['aoRestaurarEstrutura']
  ultimoResultadoCorte?: Props['ultimoResultadoCorte']
  aoSelecionar: Props['aoSelecionar']
}) {
  const ocupantes = cena.objetos.filter(
    (o) => o.vitima?.local.tipo === 'veiculo' && o.vitima.local.idVeiculo === objeto.id,
  )
  const [vidroSelecionado, setVidroSelecionado] = useState<IdVidro>('parabrisa')
  const [ferramentaVidro, setFerramentaVidro] = useState<FerramentaVidro>('glasMaster')
  const [pecaAlvo, setPecaAlvo] = useState<string>(veiculo.pecaSelecionada ?? 'portaDianteiraEsquerda')
  const [alvoDeformacao, setAlvoDeformacao] = useState<RegiaoDanoVeicular | IdPortaTabletop>('frente')
  const idPortaDeformacao = alvoDeformacao.startsWith('porta') ? alvoDeformacao as IdPortaTabletop : undefined
  const regiaoDeformacao: RegiaoDanoVeicular = idPortaDeformacao
    ? idPortaDeformacao.endsWith('Esquerda') ? 'lateralEsquerda' : 'lateralDireita'
    : alvoDeformacao as RegiaoDanoVeicular
  const deformacaoNaRegiao = (veiculo.deformacoes ?? (veiculo.deformacao ? [veiculo.deformacao] : []))
    .find((item) => item.regiao === regiaoDeformacao && item.idPorta === idPortaDeformacao)

  return (
    <fieldset className="inspetor-veiculo">
      <legend>Veículo</legend>
      <label className="campo">
        <span>modelo</span>
        <select
          value={veiculo.idPerfil}
          onChange={(e) => aoAtualizarVeiculo(objeto.id, { idPerfil: e.target.value as BlocoVeiculoTabletop['idPerfil'] })}
        >
          {Object.values(PERFIS_VEICULO).map((p) => (
            <option key={p.id} value={p.id}>{p.nome}</option>
          ))}
        </select>
      </label>
      <div className="posicao-final-tabletop" role="group" aria-label="Posição final do veículo">
        {POSICOES_FINAIS_VEICULO.map((posicao) => (
          <button
            key={posicao}
            className={veiculo.posicaoFinal === posicao ? 'ativo' : ''}
            onClick={() => aoDefinirPosicaoFinal(objeto.id, posicao)}
          >
            {ROTULOS_POSICAO_FINAL[posicao]}
          </button>
        ))}
      </div>
      {ocupantes.length === 0 ? (
        <p className="dica">Nenhuma vítima vinculada a este carro.</p>
      ) : (
        <div className="ocupantes-veiculo-grupo">
          <span className="subtitulo-ocupantes">Ocupantes ({ocupantes.length}) - clique para selecionar:</span>
          <div className="ocupantes-veiculo-botoes">
            {ocupantes.map((oc) => {
              const rotulo = oc.nome
              const triagem = oc.vitima?.triagem ?? 'amarelo'
              return (
                <button
                  key={oc.id}
                  type="button"
                  className={`btn-ocupante-carro btn-ocupante-carro--${triagem}`}
                  onClick={() => aoSelecionar(oc.id)}
                  title={`Selecionar ${oc.nome}`}
                >
                  <span className="btn-ocupante-carro__icone"><IconeVitima tamanho={14} /></span>
                  <span className="btn-ocupante-carro__rotulo">{rotulo}</span>
                </button>
              )
            })}
          </div>
        </div>
      )}

      <fieldset className="deformacao-veiculo-tabletop">
        <legend>Amassar carro</legend>
        {pincel && (
          <div className="pincel-amassado-tabletop">
            <button
              type="button"
              className={pincel.ativo ? 'ativo' : ''}
              aria-pressed={pincel.ativo}
              onClick={() => pincel.aoAlternar(!pincel.ativo)}
            >
              {pincel.ativo ? 'Desligar pincel' : 'Amassar tocando no carro'}
            </button>
            {pincel.ativo && (
              <>
                <p className="dica">Toque ou clique na lata para criar um amassado. A prévia mostra a área afetada.</p>
                <label className="campo">
                  <span>Tamanho: {Math.round(pincel.larguraM * 100)} cm</span>
                  <input type="range" min="0.25" max="1.2" step="0.05" value={pincel.larguraM}
                    onChange={(e) => pincel.aoDefinirLargura(Number(e.target.value))} />
                </label>
                <label className="campo">
                  <span>Profundidade: {Math.round(pincel.intrusaoM * 100)} cm</span>
                  <input type="range" min="0.08" max="0.45" step="0.01" value={pincel.intrusaoM}
                    onChange={(e) => pincel.aoDefinirIntrusao(Number(e.target.value))} />
                </label>
              </>
            )}
            <button type="button" onClick={() => pincel.aoRestaurar(objeto.id)}>
              Restaurar todos os amassados
            </button>
          </div>
        )}
        <label className="campo">
          <span>Parte do carro</span>
          <select
            value={alvoDeformacao}
            onChange={(e) => setAlvoDeformacao(e.target.value as RegiaoDanoVeicular | IdPortaTabletop)}
          >
            <optgroup label="Carroceria">
              <option value="frente">Frente</option>
              <option value="traseira">Traseira</option>
              <option value="lateralEsquerda">Lateral esquerda</option>
              <option value="lateralDireita">Lateral direita</option>
              <option value="teto">Teto</option>
            </optgroup>
            <optgroup label="Portas">
              <option value="portaDianteiraEsquerda">Dianteira esquerda</option>
              <option value="portaTraseiraEsquerda">Traseira esquerda</option>
              <option value="portaDianteiraDireita">Dianteira direita</option>
              <option value="portaTraseiraDireita">Traseira direita</option>
            </optgroup>
          </select>
        </label>
        <div className="posicao-final-tabletop" role="group" aria-label="Intensidade do amassado">
          <button
            type="button"
            className={!deformacaoNaRegiao ? 'ativo' : ''}
            onClick={() => aoAplicarDeformacao?.(objeto.id, 'nenhum', undefined, regiaoDeformacao, idPortaDeformacao)}
          >
            Sem amassado
          </button>
          {(['leve', 'moderado', 'severo'] as const).map((nivel) => (
            <button
              key={nivel}
              type="button"
              className={deformacaoNaRegiao?.nivel === nivel ? 'ativo' : ''}
              onClick={() => aoAplicarDeformacao?.(objeto.id, nivel, undefined, regiaoDeformacao, idPortaDeformacao)}
            >
              {nivel.charAt(0).toUpperCase() + nivel.slice(1)}
            </button>
          ))}
        </div>
        {deformacaoNaRegiao && (
          <p className="dica">
            Amassado visual de aproximadamente {Math.round(deformacaoNaRegiao.intrusaoM * 100)} cm nesta região.
          </p>
        )}
      </fieldset>

      {/* cortes e vidros (extricação veicular) só aparecem quando quem usa o painel liga o corte */}
      {!modoSimples && aoExecutarCorte && <><fieldset className="cortes-veiculo-tabletop">
        <legend>Peças e cortes estruturais</legend>
        <label className="campo">
          <span>peça</span>
          <select
            value={pecaAlvo}
            onChange={(e) => {
              setPecaAlvo(e.target.value)
              aoSelecionarPecaVeiculo?.(objeto.id, e.target.value)
            }}
          >
            {PECAS_INTERVENCAO_TABLETOP.map((p) => (
              <option key={p.id} value={p.id}>
                {p.nome} - {veiculo.estadosPecas[p.id] ?? 'íntegra'}
              </option>
            ))}
          </select>
        </label>
        <div className="acoes-cena-tabletop">
          {pecaAlvo.startsWith('porta') && (
            <>
              <button onClick={() => aoExecutarCorte?.(objeto.id, pecaAlvo, 'aberta')}>Abrir porta</button>
              <button onClick={() => aoExecutarCorte?.(objeto.id, pecaAlvo, 'removida')}>Retirar porta</button>
            </>
          )}
          {pecaAlvo.startsWith('coluna') && (
            <>
              <button onClick={() => aoExecutarCorte?.(objeto.id, pecaAlvo, 'afastada')}>Afastar coluna</button>
              <button onClick={() => aoExecutarCorte?.(objeto.id, pecaAlvo, 'removida')}>Remover coluna</button>
            </>
          )}
          {pecaAlvo === 'teto' && (
            <>
              <button onClick={() => aoExecutarCorte?.(objeto.id, pecaAlvo, 'afastada')}>Rebater teto</button>
              <button onClick={() => aoExecutarCorte?.(objeto.id, pecaAlvo, 'removida')}>Retirar teto</button>
            </>
          )}
          {pecaAlvo === 'tampaTraseira' && (
            <>
              <button onClick={() => aoExecutarCorte?.(objeto.id, pecaAlvo, 'aberta')}>Abrir tampa</button>
              <button onClick={() => aoExecutarCorte?.(objeto.id, pecaAlvo, 'removida')}>Retirar tampa</button>
            </>
          )}
          <button onClick={() => aoRestaurarEstrutura?.(objeto.id)}>Restaurar estrutura</button>
        </div>
        {ultimoResultadoCorte && <p className="dica">{ultimoResultadoCorte.mensagem}</p>}
      </fieldset>

      <fieldset className="vidros-veiculo-tabletop">
        <legend>Vidros</legend>
        <label className="campo">
          <span>vidro</span>
          <select value={vidroSelecionado} onChange={(e) => setVidroSelecionado(e.target.value as IdVidro)}>
            {IDS_VIDRO.map((id) => (
              <option key={id} value={id}>
                {CATALOGO_VIDROS[id].nome} - {veiculo.vidros[id] ?? 'intacto'}
              </option>
            ))}
          </select>
        </label>
        <label className="campo">
          <span>ferramenta</span>
          <select value={ferramentaVidro} onChange={(e) => setFerramentaVidro(e.target.value as FerramentaVidro)}>
            <option value="glasMaster">Serra corta-vidro (Glas-Master)</option>
            <option value="puncaoAutomatica">Punção automática</option>
          </select>
        </label>
        <div className="acoes-cena-tabletop">
          <button onClick={() => aoExecutarManejoVidro(objeto.id, vidroSelecionado, ferramentaVidro)}>
            Executar
          </button>
          <button onClick={() => aoRestaurarVidros(objeto.id)}>Restaurar vidros</button>
        </div>
        {ultimoResultadoVidro && <p className="dica">{ultimoResultadoVidro.mensagemDidatica}</p>}
      </fieldset>
      </>}
    </fieldset>
  )
}

/**
 * Preparação de uma mancha de óleo/combustível: se o produto continua vazando
 * e quais materiais a regra desta aula aceita. Nenhum marcado = o efeito do
 * absorvente fica "a definir pelo instrutor" durante o atendimento.
 */
function InspetorDerramamento({
  objeto,
  aoAtualizarRisco,
}: {
  objeto: ObjetoTabletop
  aoAtualizarRisco: NonNullable<Props['aoAtualizarRisco']>
}) {
  const aceitos = objeto.risco?.materiaisAceitos ?? MATERIAIS_PADRAO_DERRAMAMENTO
  return (
    <fieldset className="inspetor-vitima">
      <legend>Risco: derramamento</legend>
      <label className="toggle">
        <input
          type="checkbox"
          checked={objeto.risco?.vazamentoAtivo ?? false}
          onChange={(e) => aoAtualizarRisco(objeto.id, { vazamentoAtivo: e.target.checked })}
        />
        vazamento ativo (continua vazando até a equipe conter)
      </label>
      <span className="titulo-controle">materiais aceitos nesta aula</span>
      <div className="atd-form-intervencao__regioes" role="group" aria-label="Materiais aceitos">
        {MATERIAIS_ABSORVENTES.map((material) => {
          const marcado = aceitos.includes(material)
          return (
            <button
              key={material}
              type="button"
              className={`atd-chip-regiao ${marcado ? 'atd-chip-regiao--ativa' : ''}`}
              aria-pressed={marcado}
              onClick={() =>
                aoAtualizarRisco(objeto.id, {
                  materiaisAceitos: marcado ? aceitos.filter((m) => m !== material) : [...aceitos, material],
                })
              }
            >
              {ROTULOS_MATERIAL[material]}
            </button>
          )
        })}
      </div>
    </fieldset>
  )
}



/**
 * Medidas e pontos de ancoragem do objeto selecionado: o que muda a forma dele
 * (ângulo da escada, altura do toco) e a lista dos lugares onde se prende algo.
 * Some para objetos que não têm nenhuma das duas coisas.
 */
function InspetorAncoragem({
  objeto,
  aoAtualizarParametros,
  aoAlterarEdicaoContinua,
}: {
  objeto: ObjetoTabletop
  aoAtualizarParametros?: Props['aoAtualizarParametros']
  aoAlterarEdicaoContinua?: Props['aoAlterarEdicaoContinua']
}) {
  const definicoes = definicoesDeParametros(objeto.tipo)
  const pontos = pontosDeAncoragem(objeto)
  if (definicoes.length === 0 && pontos.length === 0) return null
  const valores = parametrosDoObjeto(objeto)
  const editavel = Boolean(aoAtualizarParametros) && !objeto.bloqueado
  const pontosEmSerie = pontos.filter((p) => p.secundario).length

  return (
    <fieldset className="inspetor-vitima inspetor-ancoragem">
      <legend>{definicoes.length > 0 ? 'Medidas e ancoragem' : 'Pontos de ancoragem'}</legend>
      {definicoes.map((d) => (
        <div key={d.chave} className="campo">
          <span>
            {d.rotulo}{d.unidade ? ` (${d.unidade})` : ""}
          </span>
          <input
            type="range"
            aria-label={`${d.rotulo}, controle deslizante`}
            min={d.min}
            max={d.max}
            step={d.passo}
            value={valores[d.chave]}
            disabled={!editavel}
            onPointerDown={() => aoAlterarEdicaoContinua?.(true)}
            onPointerUp={() => aoAlterarEdicaoContinua?.(false)}
            onPointerCancel={() => aoAlterarEdicaoContinua?.(false)}
            onKeyDown={() => aoAlterarEdicaoContinua?.(true)}
            onKeyUp={() => aoAlterarEdicaoContinua?.(false)}
            onChange={(e) => aoAtualizarParametros?.(objeto.id, { [d.chave]: Number(e.target.value) })}
          />
          <input
            type="number"
            aria-label={`${d.rotulo}, valor`}
            min={d.min}
            max={d.max}
            step={d.passo}
            value={Number(valores[d.chave]!.toFixed(2))}
            disabled={!editavel}
            onChange={(e) => {
              const numero = Number(e.target.value)
              if (e.target.value !== '' && Number.isFinite(numero)) aoAtualizarParametros?.(objeto.id, { [d.chave]: numero })
            }}
          />
        </div>
      ))}
      {pontos.length > 0 && (
        <details>
          <summary>
            Pontos de ancoragem ({pontos.length})
          </summary>
          <ul className="lista-pontos-ancoragem">
            {pontos
              .filter((p) => !p.secundario)
              .map((p) => (
                <li key={p.id}>
                  <span className="ponto-cor" aria-hidden="true" style={{ background: CORES_USO_PONTO[p.uso] }} />
                  {p.nome} <span className="dica">({ROTULOS_USO_PONTO[p.uso].toLowerCase()})</span>
                </li>
              ))}
            {pontosEmSerie > 0 && (
              <li>
                <span className="ponto-cor" aria-hidden="true" style={{ background: CORES_USO_PONTO.ancoragem }} />
                {pontosEmSerie} degraus <span className="dica">(ancoragem)</span>
              </li>
            )}
          </ul>
        </details>
      )}
    </fieldset>
  )
}

function InspetorVitima({
  objeto,
  vitima,
  veiculos,
  ancorasLivres,
  aoAtualizarVitima,
  modoSimples,
  aoDesvincularVitima,
}: {
  objeto: ObjetoTabletop
  vitima: BlocoVitimaTabletop
  veiculos: readonly ObjetoTabletop[]
  ancorasLivres: Props['ancorasLivres']
  aoAtualizarVitima: Props['aoAtualizarVitima']
  modoSimples?: boolean
  aoDesvincularVitima: Props['aoDesvincularVitima']
}) {

  const local = vitima.local
  const noVeiculo = local.tipo === 'veiculo'
  const idVeiculoAtual = local.tipo === 'veiculo' ? local.idVeiculo : ''
  const idAncoraAtual = local.tipo === 'veiculo' ? local.idAncora : null
  const veiculoAtual = noVeiculo ? veiculos.find((v) => v.id === idVeiculoAtual) : null
  const ancorasDoAtual = idVeiculoAtual
    ? ancorasLivres(idVeiculoAtual).concat(
        // a âncora ocupada pela PRÓPRIA vítima também precisa aparecer, senão ela some do select
        idAncoraAtual !== null && !ancorasLivres(idVeiculoAtual).some((a) => a.id === idAncoraAtual)
          ? [{ id: idAncoraAtual, nome: idAncoraAtual } as AncoraOcupante]
          : [],
      )
    : []

  return (
    <fieldset className="inspetor-vitima">
      <legend>Vítima: {objeto.nome}</legend>

      {/* Cartão de Identificação Superior da Vítima */}
      <div className="inspetor-vitima__sumario">
        <div className="inspetor-vitima__sumario-principal">
          <span className="inspetor-vitima__icone-vitima">
            <IconeVitima tamanho={20} />
          </span>
          <div className="inspetor-vitima__sumario-texto">
            <h3 className="inspetor-vitima__sumario-nome">{objeto.nome}</h3>
            <span className="inspetor-vitima__sumario-status">
              {noVeiculo
                ? `${veiculoAtual?.nome ?? 'Veículo'} (${local.idAncora || 'assento'})`
                : `Solo (${ROTULOS_POSTURA_SOLO[local.postura] || 'Solo'})`}
            </span>
          </div>
        </div>
      </div>

      {/* Conteúdo da Aba Posicionamento */}
      <div className="inspetor-vitima__painel-aba inspetor-vitima__painel-aba--ativo">
        {local.tipo === 'solo' && (
          <label className="campo">
            <span>postura</span>
            <select
              value={local.postura}
              onChange={(e) => {
                const novaPostura = e.target.value as PosturaVitimaSolo
                aoAtualizarVitima(objeto.id, {
                  local: { tipo: 'solo', postura: novaPostura },
                })
                aoDesvincularVitima(objeto.id, novaPostura)
              }}
            >
              {(Object.keys(ROTULOS_POSTURA_SOLO) as PosturaVitimaSolo[]).map((postura) => (
                <option key={postura} value={postura}>{ROTULOS_POSTURA_SOLO[postura]}</option>
              ))}
            </select>
          </label>
        )}

        <label className="campo">
          <span>perfil corporal</span>
          <select
            value={vitima.idPerfil}
            onChange={(e) => aoAtualizarVitima(objeto.id, { idPerfil: e.target.value as BlocoVitimaTabletop['idPerfil'] })}
          >
            {IDS_PERFIL_VITIMA.map((id) => (
              <option key={id} value={id}>{perfilVitimaPorId(id).nome}</option>
            ))}
          </select>
        </label>

        <label className="toggle">
          <input
            type="checkbox"
            checked={vitima.colarCervical}
            onChange={(e) => aoAtualizarVitima(objeto.id, { colarCervical: e.target.checked })}
          />
          colar cervical aplicado
        </label>

        <label className="campo">
          <span>hemorragia visível (membro tingido no 3D)</span>
          <select
            value={vitima.regiaoHemorragia ?? ''}
            onChange={(e) =>
              aoAtualizarVitima(objeto.id, {
                regiaoHemorragia: (e.target.value || undefined) as BlocoVitimaTabletop['regiaoHemorragia'],
              })
            }
          >
            <option value="">Nenhuma (ou padrão da ficha)</option>
            <option value="cabeca">Cabeça / Face</option>
            <option value="torax">Tórax</option>
            <option value="abdome">Abdome</option>
            <option value="pelve">Pelve</option>
            <option value="bracoEsquerdo">Braço esquerdo</option>
            <option value="bracoDireito">Braço direito</option>
            <option value="coxaEsquerda">Coxa esquerda</option>
            <option value="coxaDireita">Coxa direita</option>
            <option value="pernaEsquerda">Perna esquerda</option>
            <option value="pernaDireita">Perna direita</option>
          </select>
        </label>

        {!modoSimples && (
          <div className="bloco-triagem-manual">
            <span className="titulo-controle">Triagem de referência do cenário</span>
            <div className="triagem-tabletop" role="group" aria-label="Triagem de referência do instrutor">
              {CORES_TRIAGEM.map((cor) => (
                <button
                  key={cor}
                  type="button"
                  className={`triagem-botao triagem-${cor} ${vitima.triagem === cor ? 'ativo' : ''}`}
                  onClick={() => aoAtualizarVitima(objeto.id, { triagem: cor })}
                >
                  {ROTULOS_TRIAGEM[cor]}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </fieldset>
  )
}

function EditorVetor({
  rotulo,
  valores,
  passo = 0.1,
  minimo,
  aoAlterar,
}: {
  rotulo: string
  valores: readonly [number, number, number]
  passo?: number
  minimo?: number
  aoAlterar: (valores: [number, number, number]) => void
}) {
  return (
    <fieldset className="vetor-tabletop">
      <legend>{rotulo}</legend>
      {(['X', 'Y', 'Z'] as const).map((eixo, indice) => (
        <label key={eixo}>
          <span>{eixo}</span>
          <input
            type="number"
            step={passo}
            min={minimo}
            value={arredondar(valores[indice])}
            onChange={(e) => {
              const numero = Number(e.target.value)
              if (!Number.isFinite(numero)) return
              const proximo: [number, number, number] = [...valores]
              proximo[indice] = minimo === undefined ? numero : Math.max(minimo, numero)
              aoAlterar(proximo)
            }}
          />
        </label>
      ))}
    </fieldset>
  )
}

const radianoParaGrau = (valor: number) => valor * 180 / Math.PI
const grauParaRadiano = (valor: number) => valor * Math.PI / 180
const arredondar = (valor: number) => Math.round(valor * 100) / 100

/**
 * Passo "Revisar" do assistente de montagem (B7): um resumo rápido do que já
 * está na cena.
 */
function RevisaoAssistenteMontagem({ cena }: { cena: CenaTabletop }) {
  const veiculos = cena.objetos.filter((o) => o.veiculo).length
  const vitimas = cena.objetos.filter((o) => o.vitima)
  const vitimasNoSolo = vitimas.filter((v) => v.vitima!.local.tipo === 'solo').length
  const outros = cena.objetos.length - veiculos - vitimas.length

  return (
    <div className="tt-revisao-assistente">
      <p className="dica-tabletop">Confira a cena antes de começar a conduzir a turma:</p>
      <ul className="tt-revisao-assistente__lista">
        <li>
          <strong>{veiculos}</strong> veículo(s)
        </li>
        <li>
          <strong>{vitimas.length}</strong> vítima(s)
          {vitimasNoSolo > 0 && ` — ${vitimasNoSolo} ainda no solo, fora de qualquer carro`}
        </li>
        <li>
          <strong>{outros}</strong> outro(s) objeto(s) de cena (riscos, obstáculos, estabilização)
        </li>
      </ul>
      {cena.objetos.length === 0 && (
        <p className="dica">A cena ainda está vazia — volte aos passos 1 e 2 para montar veículos e vítimas.</p>
      )}
    </div>
  )
}

